/**对比、综述侧边历史记录 */
<template>
  <div class="aside-history-list">
    <div class="list-title">
      <el-tooltip content="返回文献列表" placement="top" effect="dark">
        <i
          class="iconfont icon-icon-arrow-right2"
          @click="handleClickBack"
          v-if="showBack"
        />
      </el-tooltip>
      <div class="title">历史记录</div>
      <!-- <div class="search-button" @click="showSearch">
        <i class="iconfont icon-sousuo" />
      </div> -->
    </div>
    <div
      class="list-search"
      v-if="!ifShowBatchCheckbox && !pageLoading && historyData.length > 0"
    >
      <!-- <div class="back-button" @click="hideSearch">
        <i class="iconfont icon-icon-arrow-left2" />
      </div> -->
      <div class="search-input">
        <el-input
          v-model="keywords"
          style="width: 170px"
          placeholder="搜索历史记录"
          :suffix-icon="Search"
          @keyup.enter="handleSearchHistory"
        />
      </div>
      <div
        class="remove-button"
        @click="showBatchCheckbox"
        v-if="!ifShowBatchCheckbox"
      >
        <i class="iconfont icon-shanchu" />
      </div>
    </div>
    <div class="list-remove" v-if="ifShowBatchCheckbox">
      <el-checkbox
        v-model="checkAll"
        :indeterminate="isIndeterminate"
        @change="handleCheckAllChange"
      >
        全选
      </el-checkbox>
      <el-divider direction="vertical" />
      <el-button
        class="remove-button"
        @click="handleBatchRemoveHistory"
        :disabled="selectItemList.length == 0"
      >
        <i class="iconfont icon-shanchu" />
        删除
      </el-button>
      <el-divider direction="vertical" />
      <el-button class="cancel-button" @click="hideBatchCheckbox">
        <i class="iconfont icon-cuo" />
        取消
      </el-button>
    </div>
    <div class="history-list" v-if="!pageLoading && historyData.length > 0">
      <div
        class="history-item"
        v-for="item in historyData"
        :key="item"
        :class="{
          active: isActive(item),
        }"
      >
        <div
          class="history-content"
          @click="handleClickHistory(item)"
          v-if="!item.ifEditing && !ifShowBatchCheckbox"
        >
          <div class="history-header">
            <div class="history-title" v-show-tip>
              <el-tooltip :content="item.title" placement="top" effect="dark">
                <div class="ellipse">
                  <span class="ellipse-text">{{ item.title }}</span>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="history-footer">
            <div class="history-time">{{ item.createTime }}</div>
            <div class="history-button">
              <div
                class="edit-button"
                @click.stop="handleClickEditHistory(item)"
              >
                <i class="iconfont icon-bianji" />
              </div>
              <div
                class="remove-button"
                v-if="!isActive(item)"
                @click.stop="handleClickRemoveHistory(item)"
              >
                <i class="iconfont icon-shanchu" />
              </div>
            </div>
          </div>
        </div>
        <div class="history-select" v-if="ifShowBatchCheckbox">
          <el-checkbox
            v-model="item.isChecked"
            style="margin-right: 10px"
            @change="updateSelectedList"
          />
          <div class="history-title" v-show-tip>
            <el-tooltip :content="item.title" placement="top" effect="dark">
              <div class="ellipse">
                <span class="ellipse-text">{{ item.title }}</span>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="history-edit" v-if="item.ifEditing">
          <el-input
            ref="renameInputRef"
            style="width: 220px"
            v-model="newName"
            maxlength="30"
            @keyup.enter="handleClickSaveHistory(item)"
          >
            <template #suffix>
              <div class="icon-box" @click.stop="handleClickSaveHistory(item)">
                <i class="icon-check iconfont icon-dui"></i>
              </div>
              <div class="icon-box" @click.stop="handleClickCancelRename(item)">
                <i class="icon-close iconfont icon-cuo"></i>
              </div>
            </template>
          </el-input>
        </div>
      </div>
    </div>
    <!-- <div class="list-footer" v-if="!pageLoading && historyData.length > 0">
      <div
        class="footer-button"
        @click="showBatchCheckbox"
        v-if="!ifShowBatchCheckbox"
      >
        <i class="iconfont icon-shanchu" />
        批量删除
      </div>
      <div class="batch-remove" v-else>
        <el-checkbox
          v-model="checkAll"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
        >
          全选
        </el-checkbox>
        <el-button class="cancel-button" @click="hideBatchCheckbox">
          取消
        </el-button>
        <el-divider direction="vertical" />
        <el-button class="remove-button" @click="handleBatchRemoveHistory">
          <i class="iconfont icon-shanchu" />
          删除
        </el-button>
      </div>
    </div> -->
    <el-empty
      :image-size="130"
      :image="require('@/assets/imgs/literature/empty.png')"
      v-if="!pageLoading && historyData.length == 0"
      class="history-empty"
    >
      <template #description>
        <div style="color: #585858; font-size: 13px">暂无历史记录</div>
      </template>
    </el-empty>
    <!-- <el-skeleton class="history-list" v-if="pageLoading" animated>
      <template #template>
        <div class="history-list-skeleton">
          <el-skeleton-item v-for="i in 5" :key="i" />
        </div>
      </template>
    </el-skeleton> -->
  </div>
</template>

<script setup>
import {
  ref,
  watch,
  onMounted,
  defineEmits,
  defineProps,
  defineExpose,
  computed,
} from "vue";
import { httpPost } from "@/api/httpService";
import { useRoute, useRouter } from "vue-router";
import { confirmBox } from "@/utils/messageBox.js";
import { ElMessage } from "element-plus";
import { Search } from "@element-plus/icons-vue";

const router = useRouter();

const emits = defineEmits(["click", "back"]);

const props = defineProps({
  type: {
    type: String,
    default: null,
  },
  activeUid: {
    type: String,
    default: null,
  },
  showBack: {
    type: Boolean,
    default: false,
  },
});

//是否是当前的历史
const isActive = computed(() => {
  return (item) => {
    return (
      (historyType.value === "COMPARE" &&
        item.aicomparisonUid === props.activeUid) ||
      (historyType.value === "REVIEW" && item.reviewUid === props.activeUid)
    );
  };
});

const historyType = ref("");
const pageLoading = ref(false);
const historyData = ref([]); //历史记录
//获取历史列表
const getHistory = async (keywords) => {
  let params = {
    keywords: keywords,
  };
  let res;
  if (historyType.value == "COMPARE") {
    res = await httpPost(
      "/comparison/v1/searchAILiteratureComparisonLog",
      params
    );
  } else if (historyType.value == "REVIEW") {
    res = await httpPost("/review/v1/searchReviewList", params);
  }
  if (res.code == 0) {
    historyData.value = res.data;
  }
};
watch(
  () => props.type,
  async (newVal, oldVal) => {
    historyType.value = newVal;
    pageLoading.value = true;
    await getHistory();
    pageLoading.value = false;
  },
  { immediate: true }
);

const keywords = ref("");
//检索
const handleSearchHistory = async () => {
  getHistory(keywords.value);
};
//返回
const handleClickBack = () => {
  emits("back");
};
//点击历史记录
const handleClickHistory = (row) => {
  emits("click", row);
};
const newName = ref("");
//编辑历史记录
const handleClickEditHistory = (row) => {
  historyData.value.forEach((item) => {
    item.ifEditing = false;
  });
  newName.value = row.title;
  row.ifEditing = true;
};
//保存历史记录
const handleClickSaveHistory = (row) => {
  if (newName.value.trim() == "") {
    ElMessage.warning("名称不可为空");
    return;
  }
  row.title = newName.value.trim();
  row.ifEditing = false;
  saveHistory(row);
};
//修改
const saveHistory = async (row) => {
  let params;
  let res;
  if (historyType.value == "COMPARE") {
    params = {
      comparisonLogUid: row.aicomparisonUid,
      title: row.title,
    };
    res = await httpPost("/comparison/v1/updateComparisonLogTitle", params);
  } else if (historyType.value == "REVIEW") {
    params = {
      reviewUid: row.reviewUid,
      title: row.title,
    };
    res = await httpPost("/review/v1/updateReviewName", params);
  }
  if (res.code == 0) {
    ElMessage.success("修改成功");
    getHistory();
  }
};
//取消重命名
const handleClickCancelRename = (row) => {
  row.ifEditing = false;
};
//移除历史记录
const handleClickRemoveHistory = (row) => {
  confirmBox(`确认删除“${row.title}”吗？
`).then(async () => {
    removeHistory([row]);
  });
};
//批量移除历史记录
const handleBatchRemoveHistory = () => {
  if (selectItemList.value.length > 0) {
    confirmBox(`确认删除${selectItemList.value.length}篇历史记录吗？`).then(
      async () => {
        removeHistory(selectItemList.value);
      }
    );
  } else {
    ElMessage.warning("请选择要删除的记录");
  }
};
//移除历史记录
const removeHistory = async (itemList) => {
  let params;
  let idList;
  let res;
  if (historyType.value == "COMPARE") {
    idList = itemList.map((item) => {
      return item.aicomparisonUid;
    });
    params = {
      comparisonLogUids: idList,
    };
    res = await httpPost("/comparison/v1/deleteComparisonLog", params);
  } else if (historyType.value == "REVIEW") {
    idList = itemList.map((item) => {
      return item.reviewUid;
    });
    params = {
      uidList: idList,
    };
    res = await httpPost("/review/v1/deleteReview", params);
  }
  if (res.code == 0) {
    ElMessage.success("删除成功");
    hideBatchCheckbox();
    getHistory();
  }
};

//#region 批量相关
const selectItemList = ref([]);
const updateSelectedList = () => {
  selectItemList.value = historyData.value.filter((item) => item.isChecked);
  if (
    selectItemList.value.length == historyData.value.length &&
    selectItemList.value.length != 0
  ) {
    checkAll.value = true;
  } else {
    checkAll.value = false;
  }
};
const checkAll = ref(false);
const handleCheckAllChange = (val) => {
  historyData.value.forEach((item) => {
    item.isChecked = val;
  });
  updateSelectedList();
};
const isIndeterminate = computed(() => {
  return (
    selectItemList.value.length != historyData.value.length &&
    selectItemList.value.length != 0
  );
});
//多选功能
const ifShowBatchCheckbox = ref(false);
const showBatchCheckbox = () => {
  ifShowBatchCheckbox.value = true;
};
const hideBatchCheckbox = () => {
  historyData.value.forEach((item) => {
    item.isChecked = false;
  });
  updateSelectedList();
  ifShowBatchCheckbox.value = false;
};
//#endregion 批量相关
</script>

<style lang="scss" scoped>
$title-height: 32px;
$operate-height: 34px;
.aside-history-list {
  padding: 5px 0px;
  :deep(.el-skeleton__item) {
    height: 35px;
    margin-bottom: 5px;
    // padding: 20px 20px;
    border-radius: 8px;
  }
  .list-title {
    height: $title-height;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;
    .iconfont {
      font-size: 13px;
      margin-right: 10px;
      cursor: pointer;
      position: relative;
      top: 1px;
    }
    .title {
      font-family: PingFangSC-regular;
      font-weight: 550;
      color: rgba(56, 56, 56, 1);
      font-size: 15px;
    }
    // .search-button {
    //   border-radius: 5px;
    //   padding: 5px;
    //   cursor: pointer;
    //   .iconfont {
    //     font-size: 14px;
    //   }
    // }
    // .search-button:hover {
    //   background-color: rgba(155, 155, 155, 0.13);
    // }
  }
  .list-search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // padding: 0 0 0 5px;
    margin-top: 5px;
    height: $operate-height;
    // .back-button {
    //   .iconfont {
    //     color: #585858;
    //     font-size: 13px;
    //     cursor: pointer;
    //   }
    // }
    :deep(.el-input__wrapper) {
      height: $operate-height;
    }
    .remove-button {
      border-radius: 5px;
      width: $operate-height;
      height: $operate-height;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      background-color: #f7f7f7;
      .iconfont {
        font-size: 14px;
        color: #bcbcbc;
      }
    }
    .remove-button:hover {
      .iconfont {
        color: #848486;
      }
    }
  }
  :deep(.el-input__wrapper) {
    border-radius: 5px;
    background-color: #f7f7f7;
    box-shadow: none;
  }
  .list-remove {
    height: $operate-height;
    border-radius: 6px;
    margin-top: 5px;
    text-align: left;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f7f7f7;
    .cancel-button {
      border: none;
      font-size: 13px;
      height: 26px;
      width: 60px;
      background-color: transparent;
      color: #383838;
      .iconfont {
        margin-right: 4px;
        font-size: 13px;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .cancel-button:hover {
      color: #383838;
    }
    :deep(.el-checkbox__label) {
      font-size: 13px;
      color: #383838;
      margin-right: 8px;
    }
    .remove-button {
      font-size: 13px;
      border: none;
      height: 26px;
      width: 60px;
      background-color: transparent;
      color: #db1300;
      .iconfont {
        margin-right: 5px;
        font-size: 13px;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .remove-button:hover {
      color: #db1300;
    }
    .remove-button.is-disabled {
      color: #bcbcbc;
    }
  }
  .history-list-skeleton {
    padding: 0 5px 0 5px;
    margin-top: 10px;
  }
  .history-list {
    height: calc(
      100vh - $header-height - $title-height - $operate-height - 40px
    ); // 40边距
    line-height: 20px;
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-regular;
    overflow: auto;
    margin-right: -10px;
    padding-right: 5px;
    .history-item {
      margin-top: 5px;
      .history-content {
        cursor: pointer;
        border-radius: 8px;
        padding: 10px;
        .history-header {
          .history-title {
            color: #585858;
            .ellipse {
              @include hidden-with-ellipsis();
              .ellipse-text {
              }
            }
          }
        }

        .history-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 5px;
          .history-time {
            color: #bcbcbc;
            font-size: 13px;
          }
          .history-button {
            display: flex;
            color: #bcbcbc;
            gap: 5px;
            display: none;
            .edit-button {
              width: 16px;
              height: 16px;
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 4px;
              .iconfont {
                color: #bcbcbc;
                font-size: 12px;
              }
            }
            .remove-button {
              width: 16px;
              height: 16px;
              border-radius: 4px;
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              .iconfont {
                color: #bcbcbc;
                font-size: 12px;
              }
            }
            .edit-button:hover {
              background-color: #ebebeb;
            }
            .remove-button:hover {
              background-color: #ffe3e3;
              .iconfont {
                color: #db1300;
              }
            }
          }
        }
      }
      .history-content:hover {
        background: #f8f8f8;
        .history-button {
          display: flex;
        }
      }
      .history-select {
        cursor: pointer;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        align-items: center;
        .history-title {
          color: #585858;
          width: 180px;
          .ellipse {
            @include hidden-with-ellipsis();
            .ellipse-text {
            }
          }
        }
      }
      .history-select:hover {
        background: #f8f8f8;
      }
      .history-edit {
        display: flex;
        align-items: center;
        padding: 10px 2px;
        :deep(.el-input__wrapper) {
          background-color: #fff;
          border: 1px solid $theme-color;
        }
        .icon-box {
          margin-left: 5px;
          cursor: pointer;
          width: 16px;
          height: 16px;
          border-radius: 3px;
          display: flex;
          justify-content: center;
          align-items: center;
          .iconfont {
            color: #bcbcbc;
            font-size: 12px;
          }
        }
        .icon-box:hover {
          background-color: #f5f5f5;
        }
      }
    }
    .active {
      .history-content {
        background-color: #f3faf9;
        .history-header {
          .history-title {
            color: $theme-color;
          }
        }
        .history-footer {
          .history-button {
            .edit-button:hover {
              background-color: #dbf0ee;
            }
          }
        }
      }
      .history-content:hover {
        background-color: #f3faf9;
      }
    }
  }
  // .list-footer {
  //   text-align: left;
  //   padding: 0 10px;
  //   .footer-button {
  //     padding: 6px;
  //     color: #848486;
  //     cursor: pointer;
  //     width: 90px;
  //     text-align: center;
  //     border-radius: 5px;
  //     font-size: 13px;
  //     position: relative;
  //     left: -10px;
  //     .iconfont {
  //       font-size: 13px;
  //     }
  //   }
  //   .footer-button:hover {
  //     background-color: #f8f8f8;
  //   }
  //   .batch-remove {
  //     display: flex;
  //     align-items: center;
  //     justify-content: space-between;
  //     .cancel-button {
  //       border: none;
  //       font-size: 13px;
  //     }
  //     .cancel-button:hover {
  //       background-color: #fff;
  //     }
  //     :deep(.el-checkbox__label) {
  //       font-size: 13px;
  //     }
  //     .remove-button {
  //       font-size: 13px;
  //       border: none;
  //       height: 26px;
  //       width: 60px;
  //       .iconfont {
  //         margin-right: 5px;
  //         font-size: 13px;
  //         display: inline-block;
  //         vertical-align: middle;
  //       }
  //     }
  //     .remove-button:hover {
  //       background-color: #ffe3e3;
  //       color: #db1300;
  //     }
  //   }
  // }
  .history-empty {
    height: calc(100vh - $header-height - $title-height - 40px);
  }
}
</style>
